export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyCUAVogUyddlEnpI2MbIGl8P4gghsAg-eI",
    authDomain: "libertycon19.firebaseapp.com",
    databaseURL: "https://libertycon19.firebaseio.com",
    projectId: "libertycon19",
    storageBucket: "libertycon19.appspot.com",
    messagingSenderId: "353635471647"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts